import { graphql, HttpResponse } from 'msw'
import { type EnrollmentIntroData, type EnrollmentIntroSubmitOutput } from '../../../models'

export const getEnrollmentIntroDataMock: EnrollmentIntroData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/intro',
}

export const submitEnrollmentIntroDataMock: EnrollmentIntroSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/account-selection',
}

export const mockGetEnrollmentIntroData = graphql.mutation('getEnrollmentIntroData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentIntroDataMock } })
})

export const mockSubmitEnrollmentIntroData = graphql.mutation('submitEnrollmentIntroData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentIntroDataMock } })
})

export const mockEnrollmentIntro = [mockGetEnrollmentIntroData, mockSubmitEnrollmentIntroData]
